import React from 'react'
import { Button, ConfigProvider } from 'antd'

import { btnCls } from '../PlanCard/classes'

import {
  type ICommonButtonProps,
  usePayButton,
} from '@/contexts/PlanContext/hooks/payButton'
import { EProductType } from '@/contexts/PlanContext/type'
import StyledButton from '@/pages/tad.ai/_components/StyledButton'


import { useMemo } from 'react';
import { tw } from 'tagged-classnames-free';
export interface IPlanButtonProps extends ICommonButtonProps {
  className?: string
}

const PlanButton: React.FC<IPlanButtonProps> = (props) => {
  const { className, type, productPriceCredits, appName, payStepInfo } = props

  const isPro = type === EProductType.PRO

  const {
    status,
    text,
    onClick,
    upgradeLoading,
    buttonLoading,
    isMonth,
    btnDisabled,
  } = usePayButton({
    appName,
    payStepInfo,
    type,
    productPriceCredits,
  })

  const buttonProps = useMemo(() => {
    return {
      disabled: btnDisabled,
      onClick,
      loading: buttonLoading ? { delay: 200 } : false,
      className: tw`
        ${btnCls}
        ${className}
        ${!btnDisabled ? 'hover:!bg-f-primary-hover' : ''}
        ${!btnDisabled ? 'hover:!text-f-text' : ''}
      `,
    }
  }, [btnDisabled, buttonLoading, className, onClick])

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            // 透明
            borderColorDisabled: 'transparent',
          },
        },
      }}
    >
      {!isPro ? (
        <StyledButton {...buttonProps}>{text}</StyledButton>
      ) : (
        <Button {...buttonProps} type='primary'>
          {text}
        </Button>
      )}
    </ConfigProvider>
  )
}

export default PlanButton
